var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClass},[_c('div',{staticClass:"app-content"},[_c('PDFViewer',{ref:"pdfRef",attrs:{"source":_vm.pdfFile,"controls":_vm.controls,"filename":_vm.filename},on:{"download":_vm.downloadPdf}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }